/* istanbul ignore file */

import { mainApi } from "config";
import { getClientFor } from "infrastructure/http";
import { ILocale } from "infrastructure/localization";

export const getLocales = async (filter?: string) => {
  return (await getClientFor(mainApi.name).get<ILocale[]>("/locales", { params: { filter: filter } })).data;
};
